module.exports = __webpack_public_path__ + "img/dada.4ef733c8.png";